<script setup lang="ts">
import HotelCardSection from './card-section/sections/HotelCardSection.vue';
import HotelCardLoader from './card-section/sections/HotelCardLoader.vue';
import type HotelPackage from '@itinerary/hotel/HotelPackage';
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';

defineProps<{
    showHotelsOnMap?: boolean;
}>();

const emit = defineEmits<{
    closeMap: [];
    openFilters: [];
    view: [];
}>();

const itineraryStore = useItineraryStore();
const { reservableList, loading } = storeToRefs(itineraryStore);
const mapHotelList = computed(() =>
    (reservableList.value as HotelPackage[])
        .slice()
        .sort((a, b) => (a.latitude || 0) - (b.latitude || 0))
);
const currentModule = useCurrentItineraryModule();
const { currentLoadingStatus } = moduleToRefs(currentModule.value);
const isMounted = useMounted();

const isLoading = computed(
    () =>
        loading.value ||
        currentLoadingStatus.value === LoadingStatus.None ||
        !process.client ||
        !isMounted.value
);
</script>
<template>
    <HotelCardLoader v-if="isLoading" :count="4" />
    <HotelCardSection
        v-else
        key="hotel-reservable-list"
        class="cards-container"
        display-banners
        :list="reservableList as HotelPackage[]"
        :map-hotel-list
        :show-map="showHotelsOnMap"
        @view-section="emit('view')"
        @close-map="emit('closeMap')"
        @open-filters="emit('openFilters')"
    />
</template>
<style scoped lang="scss">
.cards-container {
    margin-top: 4px;
}
</style>
